// Inicio sesión
export const INICIANDO_SESION='INICIANDO_SESION';
export const SESION_INICIADA='SESION_INICIADA';
export const SESION_NO_INICIADA='SESION_NO_INICIADA';
